import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Form, FormGroup, Label, Input, Col, Row, FormFeedback } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import i18n from '../../../i18next';

import TableHour from '../../common/TableHour';
import TableMinute from '../../common/TableMinute';
import { dispatchErrorMessage } from '../../../actions/index';

const INITIAL_CUSTOM_AVAILABLE_TIME = {
    day: null,
    openHour: '',
    openMinute: '',
    closeHour: '',
    closeMinute: '',
    maximumNumberOfOrders: null
};

class PromotionValidityScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promotionId: null,
            startDate: null,
            endDate: null,
            validOnMonday: null,
            validOnTuesday: null,
            validOnWednesday: null,
            validOnThursday: null,
            validOnFriday: null,
            validOnSaturday: null,
            validOnSunday: null,
            customTime: null,
            customAvailableTime: null,
            invalidForm: false,
            stateAlreadyCopiedFromProps: false
        };
    }

    copyStateFromProps() {
        if (this.props.promotionId !== undefined && this.props.promotionId !== null &&
            (!this.state.stateAlreadyCopiedFromProps || this.props.promotionId !== this.state.promotionId)) {
            // Turn back the dates to format supported by the datepicker
            let formattedStartDate = null;
            let formattedEndDate = null;
            (this.props.validity) ? formattedStartDate = moment(this.props.validity.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : moment();
            (this.props.validity) ? formattedEndDate = moment(this.props.validity.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : moment();

            let updatedValidity = { ...this.props.validity };
            updatedValidity.startDate = formattedStartDate;
            updatedValidity.endDate = formattedEndDate;

            this.setState({
                promotionId: this.props.promotionId,
                startDate: this.props.validity ? updatedValidity.startDate : null,
                endDate: this.props.validity ? updatedValidity.endDate : null,
                validOnMonday: this.props.validity ? this.props.validity.validOnMonday : true,
                validOnTuesday: this.props.validity ? this.props.validity.validOnTuesday : true,
                validOnWednesday: this.props.validity ? this.props.validity.validOnWednesday : true,
                validOnThursday: this.props.validity ? this.props.validity.validOnThursday : true,
                validOnFriday: this.props.validity ? this.props.validity.validOnFriday : true,
                validOnSaturday: this.props.validity ? this.props.validity.validOnSaturday : true,
                validOnSunday: this.props.validity ? this.props.validity.validOnSunday : true,
                customTime: this.props.validity ? this.props.validity.customTime : null,
                customAvailableTime: this.props.validity ? this.props.validity.customAvailableTime : null,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    componentWillUnmount() {
        // Make the dates in the correct format for the server
        let formattedStartDate = moment(this.state.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
        let formattedEndDate = moment(this.state.endDate, 'YYYY-MM-DD').format('DD-MM-YYYY');

        // Remove string zero from time if there is any
        let formattedCustomAvailableTime = this.formatTimeDataForSave();

        // It is not proper to do it like this but if we use setState we will not have time to update the state before the component unmounts and we will send the old data
        this.state.customAvailableTime = formattedCustomAvailableTime;
        this.state.invalidForm = false;

        let stateCopied = { ...this.state };
        stateCopied.startDate = formattedStartDate;
        stateCopied.endDate = formattedEndDate;

        // Send the updated state data to the parent component
        this.props.getPageData(stateCopied);
    }

    negativeIntegersValidation(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode === 45 || inputKeyCode === 46 || inputKeyCode === 43
                || inputKeyCode === 69 || inputKeyCode === 101) {
                e.preventDefault();
            }
        }
    }

    handleTabValidation() {
        const {
            startDate, endDate, validOnMonday,
            validOnTuesday, validOnWednesday, validOnThursday,
            validOnFriday, validOnSaturday, validOnSunday,
            customTime, customAvailableTime
        } = this.state;

        let validFormData = true;

        if (!startDate) {
            this.state.invalidForm = true;
            this.props.cancelTabChangeRequest();
            validFormData = false;

            return validFormData;
        } else if (startDate === 'Invalid date') {
            this.state.invalidForm = true;
            this.props.cancelTabChangeRequest();
            validFormData = false;

            return validFormData;
        }

        if (!endDate) {
            this.state.invalidForm = true;
            this.props.cancelTabChangeRequest();
            validFormData = false;

            return validFormData;
        } else if (endDate === 'Invalid date') {
            this.state.invalidForm = true;
            this.props.cancelTabChangeRequest();
            validFormData = false;

            return validFormData;
        }

        let startDateBeforeEndDate = moment(startDate).isAfter(endDate);

        if (startDateBeforeEndDate) {
            this.state.invalidForm = true;
            this.props.cancelTabChangeRequest();
            validFormData = false;
            this.props.dispatchErrorMessage(i18n.t('screens:promotionValidityScreen.startEndDateValidation'));

            return validFormData;
        }

        if (!validOnMonday && !validOnTuesday &&
            !validOnWednesday && !validOnThursday &&
            !validOnFriday && !validOnSaturday && !validOnSunday) {
            this.state.invalidForm = true;
            this.props.cancelTabChangeRequest();
            validFormData = false;

            return validFormData;
        }

        if (customTime) {
            if ((customAvailableTime.openHour === null || customAvailableTime.openMinute === null
                || customAvailableTime.closeHour === null || customAvailableTime.closeMinute === null) ||
                (customAvailableTime.openHour === '' || customAvailableTime.openMinute === '' || customAvailableTime.closeHour === '' ||
                    customAvailableTime.closeMinute === '')) {
                this.state.invalidForm = true;
                this.props.cancelTabChangeRequest();
                validFormData = false;
                return validFormData;
            }

            if (customAvailableTime) {
                if (Number(customAvailableTime.openHour) > Number(customAvailableTime.closeHour)) {
                    this.state.invalidForm = true;
                    this.props.cancelTabChangeRequest();
                    validFormData = false;
                    this.props.dispatchErrorMessage(i18n.t('screens:promotionValidityScreen.startEndTimeValidation'));

                    return validFormData;
                }
            }
        }

        return validFormData;
    }

    submitForm() {
        let validFormData = this.handleTabValidation();

        if (validFormData) {
            this.state.invalidForm = false;
            this.props.goToNextPage();
        } else {
            this.props.setInvalidTabData();
        }
    }

    prependZeroToTimeOnCondition(target) {
        const currentOpeningHours = {
            ...this.state.customAvailableTime
        };
        // If value of the time field is less than 9 and there is no 0 in front of it appended 0
        let hasZero = /^0/.test(target.value);
        let hasCharacters = /\W+/.test(target.value);

        if (target.value >= 0 && target.value <= 9 && target.value !== '' && !hasZero) {
            currentOpeningHours[target.name] = '0' + target.value;
        }

        if (hasCharacters) {
            currentOpeningHours[target.name] = target.value;
        }

        return currentOpeningHours;
    }

    formatTimeDataForSave() {
        // Parse changed custom hours to numbers
        let formattedCustomAvailableTime = {
            ...this.state.customAvailableTime
        };

        if (this.state.customAvailableTime) {
            // If some of the hours are strings convert them to numbers
            if (typeof this.state.customAvailableTime.openHour === 'string' && this.state.customAvailableTime.openHour !== '') {
                formattedCustomAvailableTime.openHour = this.state.customAvailableTime.openHour.substring(1);
                let toNumber = Number(formattedCustomAvailableTime.openHour);
                formattedCustomAvailableTime.openHour = toNumber;
            } else if (typeof this.state.customAvailableTime.openMinute === 'string' && this.state.customAvailableTime.openMinute !== '') {
                formattedCustomAvailableTime.openMinute = this.state.customAvailableTime.openMinute.substring(1);
                let toNumber = Number(formattedCustomAvailableTime.openMinute);
                formattedCustomAvailableTime.openMinute = toNumber;
            } else if (typeof this.state.customAvailableTime.closeHour === 'string' && this.state.customAvailableTime.closeHour !== '') {
                formattedCustomAvailableTime.closeHour = this.state.customAvailableTime.closeHour.substring(1);
                let toNumber = Number(formattedCustomAvailableTime.closeHour);
                formattedCustomAvailableTime.closeHour = toNumber;
            } else if (typeof this.state.customAvailableTime.closeMinute === 'string' && this.state.customAvailableTime.closeMinute !== '') {
                formattedCustomAvailableTime.closeMinute = this.state.customAvailableTime.closeMinute.substring(1);
                let toNumber = Number(formattedCustomAvailableTime.closeMinute);
                formattedCustomAvailableTime.closeMinute = toNumber;
            }
        }

        return formattedCustomAvailableTime;
    }

    updateState({ target }) {
        this.setState({ ...this.state, [target.name]: target.value });
    }

    updateCheckboxState({ target }) {
        (target.value === 'true') ? this.setState({ ...this.state, [target.name]: false }) : this.setState({ ...this.state, [target.name]: true });
    }

    updateRadioButtonState({ target }) {
        (target.value === 'allDay') ?
            this.setState({ ...this.state, customTime: false, customAvailableTime: null }) :
            this.setState({ ...this.state, customTime: true, customAvailableTime: INITIAL_CUSTOM_AVAILABLE_TIME, invalidForm: false });
    }

    updateCustomHoursState({ target }) {
        let updatedCustomAvailableTime = { ...this.state.customAvailableTime };

        updatedCustomAvailableTime[target.name] = Number(target.value);

        this.setState({
            ...this.state,
            customAvailableTime: updatedCustomAvailableTime
        });
    }

    handleFocusOut({ target }) {
        // If target value is empty string on focus out DONT prepend Zero to the value
        if (target.value === '') {
            let updatedCustomAvailableTime = { ...this.state.customAvailableTime };

            updatedCustomAvailableTime[target.name] = target.value;

            this.setState({
                ...this.state,
                customAvailableTime: updatedCustomAvailableTime
            });
        } else {
            let updatedCustomHours = this.prependZeroToTimeOnCondition(target);

            this.setState({
                ...this.state,
                customAvailableTime: updatedCustomHours
            });
        }
    }

    renderDatePickers() {

        return (
            <Row style={styles.datePickerContainer}>
                <Col sm={5}>
                    <FormGroup row>
                        <Label for="startDate" style={styles.fromDatePickerLabel} sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerFrom')}</Label>
                        <Col sm={9}>
                            <Input
                                invalid={this.state.invalidForm && (!this.state.startDate || this.state.startDate === 'Invalid date')}
                                type="date"
                                name="startDate"
                                id="startDate"
                                placeholder="datetime placeholder"
                                value={this.state.startDate}
                                onChange={this.updateState.bind(this)}
                            />
                            <FormFeedback>{i18n.t('screens:promotionValidityScreen.datePickerErrorMessage1')}</FormFeedback>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm={5}>
                    <FormGroup row>
                        <Label for="endDate" style={styles.toDatePickerLabel} sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerTo')}</Label>
                        <Col sm={9}>
                            <Input
                                type="date"
                                name="endDate"
                                id="endDate"
                                placeholder="datetime placeholder"
                                invalid={this.state.invalidForm && (!this.state.endDate || this.state.endDate === 'Invalid date')}
                                value={this.state.endDate}
                                onChange={this.updateState.bind(this)}
                            />
                            <FormFeedback>{i18n.t('screens:promotionValidityScreen.datePickerErrorMessage2')}</FormFeedback>
                        </Col>
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    renderValidDays() {

        return (
            <div style={styles.checkboxesContainer}>
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionValidityScreen.daysMon')}</Label>
                    <Input type="checkbox" name="validOnMonday" checked={this.state.validOnMonday} value={this.state.validOnMonday} onChange={this.updateCheckboxState.bind(this)} />
                </FormGroup>
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionValidityScreen.daysTue')}</Label>
                    <Input type="checkbox" name="validOnTuesday" checked={this.state.validOnTuesday} value={this.state.validOnTuesday} onChange={this.updateCheckboxState.bind(this)} />
                </FormGroup>
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionValidityScreen.daysWed')}</Label>
                    <Input type="checkbox" name="validOnWednesday" checked={this.state.validOnWednesday} value={this.state.validOnWednesday} onChange={this.updateCheckboxState.bind(this)} />
                </FormGroup>
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionValidityScreen.daysThu')}</Label>
                    <Input type="checkbox" name="validOnThursday" checked={this.state.validOnThursday} value={this.state.validOnThursday} onChange={this.updateCheckboxState.bind(this)} />
                </FormGroup>
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionValidityScreen.daysFri')}</Label>
                    <Input type="checkbox" name="validOnFriday" checked={this.state.validOnFriday} value={this.state.validOnFriday} onChange={this.updateCheckboxState.bind(this)} />
                </FormGroup>
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionValidityScreen.daysSat')}</Label>
                    <Input type="checkbox" name="validOnSaturday" checked={this.state.validOnSaturday} value={this.state.validOnSaturday} onChange={this.updateCheckboxState.bind(this)} />
                </FormGroup>
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionValidityScreen.daysSun')}</Label>
                    <Input type="checkbox" name="validOnSunday"
                        checked={this.state.validOnSunday}
                        value={this.state.validOnSunday}
                        onChange={this.updateCheckboxState.bind(this)}
                    />
                </FormGroup>
                <FormGroup>
                    <Input type="text" style={{ height: 0, display: 'none' }}
                        invalid={
                            (this.state.invalidForm &&
                                (!this.state.validOnMonday && !this.state.validOnTuesday && !this.state.validOnWednesday
                                    && !this.state.validOnThursday && !this.state.validOnFriday && !this.state.validOnSaturday
                                    && !this.state.validOnSunday)
                            )
                        }
                    />
                    <FormFeedback>{i18n.t('screens:promotionValidityScreen.daysErrorMessage')}</FormFeedback>
                </FormGroup>
            </div>
        );
    }

    renderPromotionTime() {

        return (
            <div style={styles.promotionTimeContainer}>
                <FormGroup name="promotion_time">
                    <Label xs={2}>
                        <Input type="radio" name="promotion_time" value='allDay'
                            checked={!this.state.customTime}
                            onChange={this.updateRadioButtonState.bind(this)} />{i18n.t('screens:promotionValidityScreen.promotionAllDay')}
                    </Label>
                    <Label xs={3}>
                        <Input type="radio" name="promotion_time" value='customTime'
                            checked={this.state.customTime} onChange={this.updateRadioButtonState.bind(this)} />{i18n.t('screens:promotionValidityScreen.promotionCustomTime')}
                    </Label>
                </FormGroup>
            </div>
        );
    }

    renderHoursFields() {

        return (
            <Row style={styles.hoursContainer}>
                <AvForm inline col={6} style={{ position: 'relative' }}>
                    <Label style={styles.openHoursLabel}>{i18n.t('screens:promotionValidityScreen.promotionHoursFrom')}</Label>
                    <Input
                        type="text"
                        style={{ height: 0, display: 'none' }}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.openHour < 0 || this.state.customAvailableTime.openHour === '')}
                    />
                    <TableHour
                        type="number"
                        name="openHour"
                        placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                        customStyle={styles.posAsyncTimeInput}
                        disabled={!this.state.customTime}
                        value={this.state.customAvailableTime ? this.state.customAvailableTime.openHour : ''}
                        handleStateChange={this.updateCustomHoursState.bind(this)}
                        handleBlur={this.handleFocusOut.bind(this)}
                        onKeyPress={(e) => this.negativeIntegersValidation(e)}
                        step={1}
                        min={0}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.openHour < 0 || this.state.customAvailableTime.openHour === '')}
                    />
                    <FormFeedback style={styles.hourInvalidInput}>{i18n.t('screens:promotionValidityScreen.promotionHoursFrom')}</FormFeedback>
                </AvForm>
                <AvForm inline col={6} style={{ position: 'relative' }}>
                    <Label style={styles.openMinutesLabel}>:</Label>
                    <Input
                        type="text"
                        style={{ height: 0, display: 'none' }}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.openMinute < 0 || this.state.customAvailableTime.openMinute === '')}
                    />
                    <TableMinute
                        type="number"
                        name="openMinute"
                        placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                        customStyle={styles.posAsyncTimeInput}
                        disabled={!this.state.customTime}
                        value={this.state.customAvailableTime ? this.state.customAvailableTime.openMinute : ''}
                        handleStateChange={this.updateCustomHoursState.bind(this)}
                        handleBlur={this.handleFocusOut.bind(this)}
                        onKeyPress={(e) => this.negativeIntegersValidation(e)}
                        step={1}
                        min={0}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.openMinute < 0 || this.state.customAvailableTime.openMinute === '')}
                    />
                    <FormFeedback style={styles.minuteInvalidInput}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                </AvForm>
                <AvForm inline col={6} style={{ position: 'relative' }}>
                    <Label style={styles.closeHoursLabel}>{i18n.t('screens:promotionValidityScreen.promotionHoursTo')}</Label>
                    <Input
                        type="text"
                        style={{ height: 0, display: 'none' }}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.closeHour < 0 || this.state.customAvailableTime.closeHour === '')}
                    />
                    <TableHour
                        type="text"
                        name="closeHour"
                        placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                        customStyle={styles.posAsyncTimeInput}
                        disabled={!this.state.customTime}
                        value={this.state.customAvailableTime ? this.state.customAvailableTime.closeHour : ''}
                        handleStateChange={this.updateCustomHoursState.bind(this)}
                        handleBlur={this.handleFocusOut.bind(this)}
                        onKeyPress={(e) => this.negativeIntegersValidation(e)}
                        step={1}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.closeHour < 0 || this.state.customAvailableTime.closeHour === '')}
                    />
                    <FormFeedback style={styles.hourInvalidInput}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                </AvForm>
                <AvForm inline col={6} style={{ position: 'relative' }}>
                    <Label style={styles.closeMinutesLabel}>:</Label>
                    <Input
                        type="text"
                        style={{ height: 0, display: 'none' }}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.closeMinute < 0 || this.state.customAvailableTime.closeMinute === '')}
                    />
                    <TableMinute
                        type="text"
                        name="closeMinute"
                        placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                        customStyle={styles.posAsyncTimeInput}
                        disabled={!this.state.customTime}
                        value={this.state.customAvailableTime ? this.state.customAvailableTime.closeMinute : ''}
                        handleStateChange={this.updateCustomHoursState.bind(this)}
                        handleBlur={this.handleFocusOut.bind(this)}
                        onKeyPress={(e) => this.negativeIntegersValidation(e)}
                        step={1}
                        invalid={this.state.invalidForm && this.state.customTime &&
                            (this.state.customAvailableTime.closeMinute < 0 || this.state.customAvailableTime.closeMinute === '')}
                    />
                    <FormFeedback style={styles.minuteInvalidInput}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                </AvForm>
                <span style={styles.timeFormatInfoMessage}>{i18n.t('screens:promotionValidityScreen.promotionInfoMessage')}</span>
            </Row>
        );
    }

    render() {
        this.copyStateFromProps();

        if (!this.props) {
            return;
        }
        // If we want to change the tab validate the form before submit
        if (this.props.requestTabChange) {
            this.submitForm();
        }

        return (
            <div style={styles.formContainer}>
                <Form>
                    {this.renderDatePickers()}
                    {this.renderValidDays()}
                    {this.renderPromotionTime()}
                    {this.renderHoursFields()}
                </Form>
            </div>
        );
    }
}

export default connect(null, { dispatchErrorMessage })(PromotionValidityScreen);

const styles = {
    formContainer: {
        marginTop: 20,
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        height: 280,
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: '#f8f8f8',
        border: '1px solid #E9ECEF'
    },
    datePickerContainer: {
        marginBottom: 20
    },
    checkboxesContainer: {
        marginBottom: 20
    },
    checkboxesLabel: {
        marginRight: 5
    },
    promotionTimeContainer: {
        position: 'relative',
        left: 5,
        marginBottom: 20
    },
    posAsyncTimeInput: {
        width: 80,
        float: 'left',
        marginRight: 5
    },
    hoursContainer: {
        position: 'relative',
        left: 10
    },
    openHoursLabel: {
        marginRight: 10,
        position: 'relative',
        bottom: 5
    },
    openMinutesLabel: {
        marginRight: 10,
        marginLeft: 10,
        position: 'relative',
        bottom: 5
    },
    closeHoursLabel: {
        marginLeft: 20,
        marginRight: 10,
        position: 'relative',
        bottom: 5
    },
    closeMinutesLabel: {
        marginRight: 10,
        marginLeft: 10,
        position: 'relative',
        bottom: 5
    },
    fromDatePickerLabel: {
        position: 'relative',
        top: 5
    },
    toDatePickerLabel: {
        position: 'relative',
        top: 5
    },
    timeFormatInfoMessage: {
        fontSize: 12,
        color: '#b7b7b7',
        position: 'relative',
        top: 30,
        left: 10,
        height: 12
    },
    hourInvalidInput: {
        position: 'absolute',
        width: 120,
        top: 42,
        left: 25
    },
    minuteInvalidInput: {
        position: 'absolute',
        width: 120,
        top: 42,
        left: 15
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionValidityScreen.js